import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';

/**
 * Sales management only for users the API gives has_sales_management_access
 * (IsSalesManagement: executives and sales); everyone else lands on their home page.
 * Waits for the profile when the session has no flags yet (same as executiveGuard).
 */
export const salesManagementGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const notifications = inject(NotificationService);
  return auth.resolveExecutiveAccess().pipe(
    map(() => {
      if (auth.hasSalesManagementAccess()) return true;
      notifications.warning('toast.warning', 'common.noPageAccess');
      return router.createUrlTree([auth.getLandingRoute()]);
    })
  );
};
